var _path, _path2, _path3, _path4, _path5, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStreak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201.89,
    height: 269.591,
    viewBox: "0 0 53.417 71.329",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.286 32.923a2.24 2.24 0 00-1.4-1.596l-16.124-6.046L37.85 4.763a2.267 2.267 0 00-1.147-2.436 2.211 2.211 0 00-2.66.448L2.691 36.366a2.211 2.211 0 00-.56 2.044 2.295 2.295 0 001.4 1.595l16.123 6.046-4.087 20.519a2.267 2.267 0 001.148 2.435 2.351 2.351 0 001.036.252 2.211 2.211 0 001.623-.7l31.352-33.59a2.211 2.211 0 00.56-2.044z",
    fill: "none",
    stroke: "#ba68c8",
    strokeWidth: 4.14393568
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.286 32.923a2.24 2.24 0 00-1.4-1.596l-16.124-6.046L37.85 4.763a2.267 2.267 0 00-1.147-2.436 2.211 2.211 0 00-2.66.448L2.691 36.366a2.211 2.211 0 00-.56 2.044 2.295 2.295 0 001.4 1.595l16.123 6.046-4.087 20.519a2.267 2.267 0 001.148 2.435 2.351 2.351 0 001.036.252 2.211 2.211 0 001.623-.7l31.352-33.59a2.211 2.211 0 00.56-2.044z",
    fill: "#ba68ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.07 30.646L16.91 45.022l2.744 1.03-4.087 20.518a2.267 2.267 0 001.148 2.435 2.351 2.351 0 001.035.252 2.211 2.211 0 001.624-.7l31.352-33.59a2.211 2.211 0 00.56-2.044 2.24 2.24 0 00-1.4-1.596z",
    fill: "#9c27b0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.092 42.074l-33.943.413 9.505 3.564-4.087 20.519a2.267 2.267 0 001.148 2.435 2.351 2.351 0 001.036.252 2.211 2.211 0 001.623-.7z",
    fill: "#9c27b0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.777 2.071a2.211 2.211 0 00-1.735.704L2.691 36.365a2.211 2.211 0 00-.56 2.044 2.295 2.295 0 001.4 1.596l.447.168L37.855 3.929a2.267 2.267 0 00-1.153-1.602 2.211 2.211 0 00-.925-.256z",
    fill: "#fdfeff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.621 22.79a1.188 1.188 0 00-.501.153l-10.33 5.911a1.191 1.191 0 00-.128.087 1.191 1.191 0 00-.114.1l-.004.005a1.191 1.191 0 00-.095.108l-.01.012a1.191 1.191 0 00-.077.116.49.49 0 00-.01.017 1.191 1.191 0 00-.061.12l-.01.025a1.191 1.191 0 00-.09.443v11.984c0 .427.23.821.6 1.033l7.358 4.213v-.003l2.974 1.701a1.198 1.198 0 00.589.156 1.194 1.194 0 00.588-.156l10.33-5.911a1.188 1.188 0 00.595-1.033V29.884c0-.424-.225-.818-.595-1.03L27.3 22.943a1.188 1.188 0 00-.017-.007 1.188 1.188 0 00-.297-.116 1.188 1.188 0 00-.015-.004 1.188 1.188 0 00-.004-.001 1.188 1.188 0 00-.343-.025 1.188 1.188 0 00-.003 0z",
    fill: "#ba68c8",
    stroke: "#ba68c8",
    strokeWidth: 4.14510096
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.037 41.698h.013zm-19.468-.686l9.142 5.232 9.141-5.232V30.4l-9.141-5.232-9.145 5.232zm9.142 7.785a1.198 1.198 0 01-.589-.154L15.793 42.73a1.188 1.188 0 01-.599-1.033V29.71c0-.424.229-.817.599-1.03l10.33-5.91a1.188 1.188 0 011.177 0l10.329 5.91c.37.213.595.606.595 1.03v11.988a1.188 1.188 0 01-.595 1.033l-10.33 5.912a1.194 1.194 0 01-.588.154",
    fill: "#9c27b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.404 29.445l-2.691-1.541-6.77 3.869v7.86l4.835 2.765z",
    fill: "#fdfeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.967 44.672l-6.4-3.66V30.4l9.142-5.232 3.503 2.005.81-2.27-3.724-2.134a1.188 1.188 0 00-1.178 0l-10.329 5.912a1.191 1.191 0 00-.599 1.033v11.984c0 .427.23.821.6 1.033l7.358 4.212z",
    fill: "#fdfeff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStreak);
export default __webpack_public_path__ + "static/media/icon-streak.9aaafe1c4896363944d6a4668ede9b5b.svg";
export { ForwardRef as ReactComponent };